import saSdk from '../../../services/service-awards-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    program: {},
    programLoading: false,
    programLoadingError: null,
    awardFiles: [],
    awardFilesLoading: false,
    awardFilesLoadingError: null
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'awardFileList/setState';

/*******************************************************************************
 * Reducer
 */
export default function awardFileListReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }

        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}


function loadProgram( programId ) {
    return ( dispatch ) => {
        if ( programId ) {
            dispatch( setState( {
                programLoading: true,
                programLoadingError: null
            } ) );

            saSdk.getProgram( programId )
                .then( ( program ) => {
                    dispatch( setState( {
                        program,
                        programLoading: false
                    } ) );
                } )
                .catch( ( err ) => {
                    dispatch( setState( {
                        programLoading: false,
                        programLoadingError: err
                    } ) );
                } );
        }
    };
}

function unloadProgram( programId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            program: {},
            programLoading: false,
            programLoadingErrors: null
        } ) );
    };
}


function loadAwardFiles( programId ) {
    return ( dispatch ) => {
        if ( programId ) {
            dispatch( setState( {
                awardFilesLoading: true,
                awardFilesLoadingError: null
            } ) );

            saSdk.getAwardFiles( programId )
                .then( ( awardFiles ) => {
                    dispatch( setState( {
                        awardFiles,
                        awardFilesLoading: false
                    } ) );
                } )
                .catch( ( err ) => {
                    dispatch( setState( {
                        awardFilesLoading: false,
                        awardFilesLoadingError: err
                    } ) );
                } );
        }
    };
}

function unloadAwardFiles( programId ) {
    return ( dispatch ) => {
        dispatch( setState( {
            awardFiles: [],
            awardFilesLoading: false,
            awardFilesLoadingError: null
        } ) );
    };
}


export const actions = {
    loadProgram,
    unloadProgram,
    loadAwardFiles,
    unloadAwardFiles
};
